module.exports = __webpack_public_path__ + "img/festive-confetti.2ac680a0.gif";